import mp2023Logomark from 'media/images/mp2023-logomark.svg';

export const MP2023_LOGOMARK_METADATA = {
  src: mp2023Logomark,
  alt: `Mixpanel logo`,
  width: 140,
  height: 140,
} as const;

export const COMPANY_SIZE_OPTIONS = [
  `1`,
  `2–10`,
  `11–50`,
  `51–200`,
  `201–500`,
  `501–1,000`,
  `1,001–5,000`,
  `5,001–10,000`,
  `More than 10,000`,
];

export const DEPARTMENT_OPTIONS = [
  `Analytics`,
  `Data`,
  `Design / UX`,
  `Engineering`,
  `Executive`,
  `Growth`,
  `Marketing`,
  `Product`,
  `Other`,
];

export const MAU_SIZE_OPTIONS = [`Less than 1000`, `1000–25000`, `25000–100000`, `More than 100000`];

export const enum Step {
  UserCredentials = 0,
  ExtraDetails = 1,
}
